import React, { useState } from "react";
import Schema from "./Schema";
 import styles from "./index.module.scss";
 
export default function BlockSelector() {
 
  return (
    <div
      style={{}}
      className={styles.blockSelector}
    >
  
      <Schema></Schema>
    </div>
  );
}
